import {Inject, Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {Observable} from 'rxjs';
import {ResponseModel} from '../../models/comons/dto/ResponseModel';
import {ResourceModel} from '../../models/comons/dto/ResourceModel';
import {HttpClient} from '@angular/common/http';
import {Configuration} from '../../configuration';

@Injectable({
    providedIn: 'root'
})
export class ResourceService extends BaseService {

    constructor(private http: HttpClient) {
        super('uaa');
    }

    upload(formData: FormData): Observable<ResponseModel<ResourceModel>> {
        return this.http.post<ResponseModel<ResourceModel>>
        (`${Configuration.url}/${this.preRoute}/api/file/upload`, formData);
    }

    getFile(filename: string): Observable<any> {
        return this.http.get(`${Configuration.url}/${this.preRoute}/${filename}`);
    }

    uploadProfile(formData: FormData): Observable<ResponseModel<string>> {
        return this.http.post<ResponseModel<string>>
        (`${Configuration.url}/${this.preRoute}/api/file/upload/profile`, formData);
    }

    getProfileAvatar(username: string) {
        return `${Configuration.url}/${this.preRoute}/api/file/profile/${username}`;
    }
}
